import { LoggerConfig } from 'src/app/utils/logger'

export const environment = {
    envName: 'dev',
    softwareVersion: '1',
    API_BASE_PATH: 'https://dev2-api-mit.evida.dk',
    login: {
        basePath: 'https://preprod.auth.evida.dk/realms/mitevida',
        configurationUrl: 'https://preprod.auth.evida.dk/realms/mitevida/.well-known/openid-configuration',
        redirectUrl: window.location.origin + '/login/flow',
        redirectLogoutUrl: window.location.origin + '/login',
        privateScope: 'openid privat',
        businessScope: 'openid erhverv',
        privateClientId: 'mitevida',
        businessClientId: 'mitevida',
        emailAvailabilityEndpoint: '/api/User/EmailExists',
        emailAvailabilityDebounceMs: 500,
        emailAvailabilityTtlMs: 60000,
    },
    queueIt: {
        enabled: false,
        customer: 'evida',
        scriptInterceptDomain: 'evida.dk',
        interceptDomains: ['dev2-api-mit.evida.dk', 'preprod.auth.evida.dk'],
    },
    links: {
        login: window.location.origin + '/login',
        welcome: window.location.origin + '/evida',
    },
    features: {
        testingTools: true,
        enableWrongReceiverFlow: true,
        enableCollectConsent: true,
        enableInvoice: true,
        enableTimedata: true,
        enableMaintenance: false,
        enableEmptyPoolForDecoupling: false,
    },
    sa: {
        appName: 'Mit evida',
        enabled: true,
        loggingEnabled: true,
    },
    loggingConfig: {
        enabled: true,
        errorLogs: true,
        debugLogs: true,
        remoteReporting: false,
    } as LoggerConfig,
}
